<template>
  <div
    v-title.async="title"
    v-analytics.pageview="'maintenance'"
    class="maintenance"
  >
    <div class="maintenance-body">
      <p>系统维护中，若有不便，敬请谅解。</p>
      <p class="en">
        The website is under maintain, sorry for inconvenience.
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Maintenance',

  data() {
    return {
      title: '',
    };
  },

  mounted() {
    this.title = '系统维护中';
  },
};
</script>

<style scoped lang="scss">
.maintenance {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
  font-size: 16px;
  flex-wrap: wrap;

  .maintenance-body {
    width: 100%;
    text-align: center;
  }

  .en {
    font-size: 14px;
  }
}
</style>
